import { useEffect, useState } from 'react';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Field, FieldLabel } from '@/components/ui/field';
import { Input } from '@/components/ui/input';
import { useContactEmail, useZetContactEmail } from '../beheer/beheer.api';

/**
 * Waar een antwoord op uitgaande mail heen gaat.
 *
 * De mail komt van een noreply-adres, en op een uitnodiging wordt geantwoord.
 * Blijft dit leeg, dan stuitert dat antwoord.
 *
 * Dit stond onder Personen, op het tabblad Uitnodigingen, omdat je het daar het
 * eerst merkt. Het is alleen geen handeling maar een knop die je één keer zet,
 * en hij geldt voor élke mail die de app stuurt en niet alleen voor de
 * uitnodigingen.
 */
export function MailPaneel() {
  const { data } = useContactEmail();
  const zet = useZetContactEmail();
  const [email, setEmail] = useState('');
  const [geladen, setGeladen] = useState(false);

  useEffect(() => {
    if (data && !geladen) {
      setEmail(data.email);
      setGeladen(true);
    }
  }, [data, geladen]);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Antwoordadres</CardTitle>
      </CardHeader>
      <CardContent>
        <Field orientation="horizontal">
          <FieldLabel htmlFor="contact-email">Antwoorden gaan naar</FieldLabel>
          <Input
            className="max-w-xs"
            id="contact-email"
            onBlur={() => data && email !== data.email && zet.mutate(email)}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="beheer@veerenstael.nl"
            type="email"
            value={email}
          />
        </Field>
      </CardContent>
    </Card>
  );
}
